export default "__VITE_ASSET__da805769__"